import { render, staticRenderFns } from "./dollar-sack.vue?vue&type=template&id=435546fc&scoped=true&"
import script from "./dollar-sack.vue?vue&type=script&lang=js&"
export * from "./dollar-sack.vue?vue&type=script&lang=js&"
import style0 from "./dollar-sack.vue?vue&type=style&index=0&id=435546fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435546fc",
  null
  
)

export default component.exports